import { memo } from "react";
import { BzTabs, BzTab } from "../../../components";
import { ORDER_TYPES, WATCHLIST_GRID_INDEX } from "../../../utils/global_variables";
import { getScripOrderInfo } from "../../../redux/actions/orders";
import { useDispatch } from "react-redux";

const PlaceOrderTabs = ({ arrPlaceOrderInfo, activeTabKey, setActiveTabKey, setMultiScripOrderActiveTabKey, scripOrderInfo }) => {
    const dispatch = useDispatch();
    const handleOrderEntryTab = (eachTab) => {
        setActiveTabKey(eachTab.tabKey);
        setMultiScripOrderActiveTabKey(ORDER_TYPES.BASKET);
        if (eachTab?.tabKey === ORDER_TYPES.SINGLE_SCRIP) {
            if (scripOrderInfo[WATCHLIST_GRID_INDEX.NSPREAD] === 1) {
                dispatch(getScripOrderInfo({ isBuySell: 'BUY', activeExchangeId: scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE], scripData: [] }));
            }
        }
    };
    return (
        <div className=''>
            <BzTabs className='nav nav-tabs horizontal-scroll-wrap'>
                {arrPlaceOrderInfo?.map((eachTab) => (
                    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - Start
                    eachTab &&
                    <BzTab className='nav-link text-capitalize' key={eachTab.tabKey} tabKey={eachTab.scrip} isActive={eachTab.tabKey === activeTabKey} onClick={handleOrderEntryTab.bind(this, eachTab)}>{eachTab.scrip}</BzTab> //ManasaB : 08-10-2024 : To restrict rendering of Basket without clicking on multiscrip
                    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - End
                ))}
            </BzTabs>
        </div>
    );
};

export default memo(PlaceOrderTabs);